import React from "react"
import PropTypes from "prop-types"

class TimeLineHeaders extends React.Component {
  constructor(props) {
    super(props);
    this.state= {
      bien_id: "",
      type: "",
      cal: []
    }
  }
  componentDidMount(){
    let tmp = []
    for (var i = 0; i <= 24*60; i+=60) {
      if(i>6*60 && i<19*60){
      tmp.push({h: i,txt: i/60+"h"})
      }
    }
    this.setState({cal: tmp})
  }
  getInPour(hour){
    return( (100/(12*60))*(hour-7*60))
  }

  render () {
      return (
        <React.Fragment>
        <div id="timeline"style={{pointerEvents: "none",zIndex: "3",width: "100%",marginLeft: "auto",marginRight: "auto", height: "30px",background: "#bdc3c7"}}>
          {this.state.cal.map((event,index)=>(
              <div key={index} style={{zIndex: "3",left: this.getInPour(event.h)+"%",borderLeft: "#2c3e50 solid 2px",position: "absolute",background: "none",height: '130px'}}>
               {event.txt}
              </div>
            ))}
        </div>

        </React.Fragment>
      );
  }
}

export default TimeLineHeaders
